const map = {
	"./0/Kambi/Header.mobile.layout.js": [
		14704,
		[
			2022,
			5610
		]
	],
	"./0/Kambi/Header.pc.layout.js": [
		99185,
		[
			2022,
			8427
		]
	],
	"./0/Poker/Header.mobile.layout.js": [
		50289,
		[
			2022,
			6632
		]
	],
	"./0/Poker/Header.pc.layout.js": [
		36984,
		[
			2022,
			3442
		]
	],
	"./0/Spectate/Header.mobile.layout.js": [
		74385,
		[
			2022,
			7299
		]
	],
	"./0/Spectate/Header.pc.layout.js": [
		90744,
		[
			2022,
			7786
		]
	],
	"./1/Kambi/Header.mobile.layout.js": [
		80853,
		[
			2022,
			8343
		]
	],
	"./1/Kambi/Header.pc.layout.js": [
		32940,
		[
			2022,
			2606
		]
	],
	"./1/Poker/Header.mobile.layout.js": [
		63688,
		[
			2022,
			4622
		]
	],
	"./1/Poker/Header.pc.layout.js": [
		13289,
		[
			2022,
			9743
		]
	],
	"./1/Spectate/Header.mobile.layout.js": [
		56254,
		[
			2022,
			1142
		]
	],
	"./1/Spectate/Header.pc.layout.js": [
		14763,
		[
			2022,
			6359
		]
	],
	"./31/Kambi/Header.mobile.layout.js": [
		27720,
		[
			2022,
			1706
		]
	],
	"./31/Kambi/Header.pc.layout.js": [
		13975,
		[
			2022,
			3213,
			4251
		]
	],
	"./31/Poker/Header.mobile.layout.js": [
		86201,
		[
			2022,
			5821
		]
	],
	"./31/Poker/Header.pc.layout.js": [
		61696,
		[
			2022,
			1824
		]
	],
	"./31/Spectate/Header.mobile.layout.js": [
		15881,
		[
			2022,
			5125
		]
	],
	"./31/Spectate/Header.pc.layout.js": [
		72176,
		[
			2022,
			3213,
			8968
		]
	],
	"./58/Spectate/Header.mobile.layout.js": [
		17948,
		[
			2022,
			6242
		]
	],
	"./58/Spectate/Header.pc.layout.js": [
		24653,
		[
			2022,
			8768
		]
	],
	"./75/Kambi/Header.mobile.layout.js": [
		33440,
		[
			2022,
			7861
		]
	],
	"./75/Kambi/Header.pc.layout.js": [
		97121,
		[
			2022,
			5523
		]
	],
	"./75/Spectate/Header.mobile.layout.js": [
		23713,
		[
			2022,
			1205
		]
	],
	"./75/Spectate/Header.pc.layout.js": [
		95272,
		[
			2022,
			2136
		]
	],
	"./76/Kambi/Header.mobile.layout.js": [
		78187,
		[
			2022,
			7013
		]
	],
	"./76/Kambi/Header.pc.layout.js": [
		87030,
		[
			2022,
			792
		]
	],
	"./76/Spectate/Header.mobile.layout.js": [
		21024,
		[
			2022,
			9010
		]
	],
	"./76/Spectate/Header.pc.layout.js": [
		6305,
		[
			2022,
			7763
		]
	],
	"./8/Poker/Header.mobile.layout.js": [
		1209,
		[
			2022,
			7235
		]
	],
	"./8/Poker/Header.pc.layout.js": [
		55808,
		[
			2022,
			6362
		]
	],
	"./8/Spectate/Header.mobile.layout.js": [
		77641,
		[
			2022,
			107
		]
	],
	"./8/Spectate/Header.pc.layout.js": [
		38142,
		[
			2022,
			360,
			2242
		]
	],
	"./81/Kambi/Header.mobile.layout.js": [
		77741,
		[
			2022,
			6423
		]
	],
	"./81/Kambi/Header.pc.layout.js": [
		32772,
		[
			2022,
			8755,
			9182
		]
	],
	"./81/Spectate/Header.mobile.layout.js": [
		97334,
		[
			2022,
			316
		]
	],
	"./81/Spectate/Header.pc.layout.js": [
		18787,
		[
			2022,
			8755,
			8033
		]
	],
	"./84/Kambi/Header.mobile.layout.js": [
		34500,
		[
			2022,
			2110
		]
	],
	"./84/Kambi/Header.pc.layout.js": [
		43989,
		[
			5247
		]
	],
	"./84/Spectate/Header.mobile.layout.js": [
		89301,
		[
			2022,
			1773
		]
	],
	"./84/Spectate/Header.pc.layout.js": [
		77100,
		[
			2022,
			608
		]
	],
	"./86/Spectate/Header.mobile.layout.js": [
		57823,
		[
			2022,
			9191
		]
	],
	"./86/Spectate/Header.pc.layout.js": [
		53074,
		[
			2022,
			242,
			5054
		]
	],
	"./87/Spectate/Header.mobile.layout.js": [
		12500,
		[
			2022,
			10
		]
	],
	"./87/Spectate/Header.pc.layout.js": [
		84741,
		[
			2022,
			5339
		]
	],
	"./88/Spectate/Header.mobile.layout.js": [
		62673,
		[
			2022,
			2921
		]
	],
	"./88/Spectate/Header.pc.layout.js": [
		13656,
		[
			2022,
			9692
		]
	],
	"./89/Spectate/Header.mobile.layout.js": [
		35006,
		[
			2022,
			6580
		]
	],
	"./89/Spectate/Header.pc.layout.js": [
		77035,
		[
			2022,
			242,
			4137
		]
	],
	"./90/Spectate/Header.mobile.layout.js": [
		35608,
		[
			2022,
			782
		]
	],
	"./90/Spectate/Header.pc.layout.js": [
		86361,
		[
			2022,
			242,
			751
		]
	],
	"./91/Spectate/Header.mobile.layout.js": [
		3651,
		[
			2022,
			2795
		]
	],
	"./91/Spectate/Header.pc.layout.js": [
		39246,
		[
			2022,
			242,
			1026
		]
	],
	"./92/Spectate/Header.mobile.layout.js": [
		20646,
		[
			2022,
			8236
		]
	],
	"./92/Spectate/Header.pc.layout.js": [
		85491,
		[
			2022,
			8545
		]
	],
	"./94/Spectate/Header.mobile.layout.js": [
		31108,
		[
			2022,
			7018
		]
	],
	"./94/Spectate/Header.pc.layout.js": [
		94933,
		[
			2022,
			3979
		]
	],
	"./95/Spectate/Header.mobile.layout.js": [
		40175,
		[
			2022,
			4775
		]
	],
	"./95/Spectate/Header.pc.layout.js": [
		86730,
		[
			2022,
			6801
		]
	],
	"./96/Poker/Header.mobile.layout.js": [
		21092,
		[
			2022,
			1744
		]
	],
	"./96/Poker/Header.pc.layout.js": [
		71189,
		[
			2022,
			5093
		]
	],
	"./96/Spectate/Header.mobile.layout.js": [
		11170,
		[
			2022,
			9240
		]
	],
	"./96/Spectate/Header.pc.layout.js": [
		77919,
		[
			2022,
			360,
			8157
		]
	],
	"./default/Kambi/Header.mobile.layout.js": [
		94143,
		[
			2022,
			9105
		]
	],
	"./default/Kambi/Header.pc.layout.js": [
		33658,
		[
			5108
		]
	],
	"./default/Spectate/Header.mobile.layout.js": [
		55812,
		[
			2022,
			976
		]
	],
	"./default/Spectate/Header.pc.layout.js": [
		48245,
		[
			9397
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 68133;
module.exports = webpackAsyncContext;